import React, { useState, useContext, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AppContext from '../../context/AppContext';

// Version améliorée de PaymentSheet pour résoudre le problème d'erreur "Illegal constructor"
const PaymentSheet = () => {
  const [isOpen, setIsOpen] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const context = useContext(AppContext);
  
  // Utiliser une approche sécurisée pour accéder aux fonctions du contexte
  const setShowPaymentSheet = context?.setShowPaymentSheet || (() => {});

  // Si le contexte n'est pas disponible, utilisez des valeurs par défaut
  const [aggregators, setAggregators] = useState({
    fedapay: {
      name: 'FedaPay',
      isConfigured: false
    },
    monero: {
      name: 'Monero',
      isConfigured: false
    }
  });

  // Cleanup lors du démontage du composant
  useEffect(() => {
    return () => {
      // Nettoyage sécurisé lors du démontage
      if (context && typeof setShowPaymentSheet === 'function') {
        setShowPaymentSheet(false);
      }
    };
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    // Appel sécurisé de la fonction
    if (typeof setShowPaymentSheet === 'function') {
      setShowPaymentSheet(false);
    }
    // Rediriger vers la page des paramètres
    navigate('/PaymentsSheetsIndex');
  };

  const handleAddMethod = () => {
    // Appel sécurisé de la fonction
    if (typeof setShowPaymentSheet === 'function') {
      setShowPaymentSheet(false);
    }
    navigate('/AjouterMethode');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-end justify-center">
      <div className="bg-white w-full max-w-md rounded-t-xl p-6 animate-slide-up">
        <div className="flex justify-center mb-4">
          <div className="w-12 h-1 bg-gray-300 rounded-full" />
        </div>
        
        <h2 className="text-xl font-semibold mb-4">Moyens de paiement</h2>
        <p className="text-gray-600 mb-6">
          Configurez vos moyens de paiement pour accepter les transactions
        </p>
        
        <div className="space-y-4">
          <button
            onClick={handleAddMethod}
            className="w-full bg-blue-600 text-white font-medium py-3 px-4 rounded-lg"
          >
            Ajouter un moyen de paiement
          </button>
          
          <button
            onClick={handleClose}
            className="w-full bg-gray-100 text-gray-700 font-medium py-3 px-4 rounded-lg"
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSheet;